<template>
  <!-- color specifies magnifier color when field got focus                             -->
  <!-- solo-inverted makes activated background color dark                              -->
  <!--  :autocomplete="Date.now()" to disable autofill function of chrome-->
  <!-- <v-text-field filled rounded dense label="Information versenden"></v-text-field> -->
  <v-text-field v-model="search"
                :label="$t('search.placeholder')"
                :color="theme.elements.btnColor"
                :dense="xs"
                autofocus
                autocomplete="off"
                filled
                rounded
                hide-details
                clearable
                style="width:300px"
                class="d-flex px-3 my-0 py-0"
                @click:clear="search = ''"
                @keydown="(event) => $emit('onKeyDown', event)">
    <template v-slot:prepend>
      <search-info v-if="false" :isInFulltextSearchMode="isInFulltextSearchMode"></search-info>
    </template>
  </v-text-field>
</template>

<script>
import SearchInfo from './SearchInfo.vue';
import commonMixin from '@/mixins/common';
export default {
  name: 'SearchField',
  mixins: [commonMixin],
  components: { SearchInfo },

  props: {
    isInFulltextSearchMode: {
      type: Boolean,
    },
  },

  computed: {
    search: {
      // getter
      get() {
        return this.$store.state.search.search;
      },
      // setter
      set(value) {
        this.$store.commit('search/setSearch', value);
      },
    },
  },
};
</script>
